import { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";

const iconStyle = {
  width: "40px",
  height: "40px",
  marginTop: "15px",
  color: "#DD4949",
};

export default function ErrorModal({
  openModal,
  errorMsg,
  handleCloseModal,
  consoleMsg,
  config,
}) {
  const setting = config.scannerErr_setting;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  // const [errCode, setErrCode] = useState(consoleMsg || null);

  // useEffect(() => {
  //   if (consoleMsg) setErrCode(consoleMsg);
  // }, [consoleMsg]);

  useEffect(() => {
    if (open !== openModal) setOpen(openModal);
  }, [openModal]);

  useEffect(() => {
    if (errorMsg) {
      // errorMsg === "warnBrowser" ? setMsg(t("warnBrowser")) : setMsg(errorMsg);
      switch (errorMsg) {
        case "warnBrowser":
          return setMsg(t("warnBrowser"));
        case "timeout":
          return setMsg(t("errMsg_code_timeout"));
        case "networkErr":
          return setMsg(t(`${setting.errMsg.networkErr}`));
        case "serverErr":
          return setMsg(t(`${setting.errMsg.serverBusy}`));
        case "unknownErr":
          return setMsg(t(`${setting.errMsg.unknownErr}`));
        default:
          return setMsg(errorMsg);
      }
      // } else if (!errorMsg && consoleMsg) {
      //   setErrCode(consoleMsg);
    }
  }, [errorMsg]);

  useEffect(() => {
    if (msg.includes(t("errMsg_expense_no_less"))) {
      setTimeout(() => {
        handleCloseModal();
      }, 2000);
    }
  }, [msg]);

  const handleRedirect = () => {
    localStorage.clear();
    sessionStorage.clear();
    // Clear the access_token cookie
    document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.replace("/");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="errorModal" style={{ width: "300px", height: "180px" }}>
          {msg.includes(t("errMsg_expense_no_less")) && (
            <CancelOutlinedIcon style={iconStyle} />
          )}
          {msg.includes(t("forgetPwd_msg")) ? (
            <h3 style={{ margin: "10px 0 0" }}>
              <CheckCircleOutlineIcon
                style={{
                  color: config.theme.color,
                  fontSize: "25px",
                  marginBottom: "-7px",
                  marginRight: "5px",
                }}
              />
              {msg}
            </h3>
          ) : (
            <h4 style={{ margin: "10px 0" }}>
              {msg &&
                msg.split("\n").map((line) => (
                  <p
                    key={line}
                    style={{
                      margin: "5px 0 0",
                    }}
                  >
                    {line}
                  </p>
                ))}
            </h4>
          )}

          {consoleMsg && <p>{consoleMsg}</p>}
          {!msg.includes(t("errMsg_expense_no_less")) && (
            <button
              className="colorBtn"
              style={{
                minHeight: "35px",
                // display: !msg.includes(t("forgetPwd_msg")) ? "block" : "none",
              }}
              onClick={
                errorMsg === t(`${setting.errMsg.invalidToken}`)
                  ? handleRedirect
                  : handleCloseModal
              }
            >
              {t(`${setting.buttons[0].label}`)}
            </button>
          )}
        </div>
      </Modal>
    </>
  );
}
